<script lang="ts">
	//UI
	//Utils
	import { navigate } from "svelte-routing";
	//Props
	export let path = "/";
	//Types
	//Constants
	//Variables
	//Functions
	//Do
	navigate(path);

</script>

<style lang="scss">
</style>
